import React from 'react';
import UnitIcon from '@gameobjects/UnitIcon';
import SpawnBeaconIcon from '@gameobjects/SpawnBeaconIcon';

// Future imports for new object types
// import ObstacleIcon from '@gameobjects/ObstacleIcon';
// import ItemIcon from '@gameobjects/ItemIcon';
// import EffectIcon from '@gameobjects/EffectIcon';

/**
 * Renderiza el componente correcto basado en el tipo de objeto del mapa.
 * Unified renderer for all map objects using the new mapObjects structure.
 * @param {object} object - El objeto del mapa (unidad, beacon, obstacle, item, etc.).
 */
function MapObjectRenderer({ object }) {
  if (!object) {
    console.warn('[MapObjectRenderer] No se proporcionó un objeto válido para renderizar'); 
    return null;
  }

  switch (object.type) {
    // Dynamic objects
    case 'unit':
      return <UnitIcon unitId={object.id} size="map" showInitiative={true} />;

    case 'structure':
      // Check for spawn beacon subtype
      if (object.subtype === 'spawn_beacon') {
        return <SpawnBeaconIcon beacon={object} size="small" />;
      }
      // Other structures (turrets, bases) use unit icon (no initiative for structures)
      return <UnitIcon unitId={object.id} size="map" showInitiative={false} />;
    
    case 'destructible':
      // Destructible obstacles
      // return <DestructibleIcon destructible={object} size="small" />;
      console.log('[MapObjectRenderer] Destructible rendering not yet implemented');
      return null;
    
    // Static objects
    case 'obstacle':
      // return <ObstacleIcon obstacle={object} size="small" />;
      console.log('[MapObjectRenderer] Obstacle rendering not yet implemented');
      return null;
    
    case 'ornament':
      // Pure decorative elements (trees, rocks, etc.)
      // return <OrnamentIcon ornament={object} size="small" />;
      console.log('[MapObjectRenderer] Ornament rendering not yet implemented');
      return null;
    
    // Interactables
    case 'item':
      // return <ItemIcon item={object} size="small" />;
      console.log('[MapObjectRenderer] Item rendering not yet implemented');
      return null;
    
    case 'trigger':
      // return <TriggerIcon trigger={object} size="small" />;
      console.log('[MapObjectRenderer] Trigger rendering not yet implemented');
      return null;

    default:
      console.warn(`[MapObjectRenderer] No se encontró un componente para el tipo: "${object.type}"`);
      return null;
  }
}

export default MapObjectRenderer;